var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraftjobsStIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FDEAD7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FEF6EE",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.0002H22.8C21.1198 20.0002 20.2798 20.0002 19.638 20.3272C19.0735 20.6148 18.6146 21.0738 18.327 21.6383C18 22.28 18 23.1201 18 24.8002V33.2002C18 34.8804 18 35.7205 18.327 36.3622C18.6146 36.9267 19.0735 37.3856 19.638 37.6732C20.2798 38.0002 21.1198 38.0002 22.8 38.0002H31.2C32.8802 38.0002 33.7202 38.0002 34.362 37.6732C34.9265 37.3856 35.3854 36.9267 35.673 36.3622C36 35.7205 36 34.8804 36 33.2002V29.0002M24 32.0002H25.6745C26.1637 32.0002 26.4083 32.0002 26.6385 31.945C26.8425 31.896 27.0376 31.8152 27.2166 31.7055C27.4184 31.5818 27.5914 31.4089 27.9373 31.063L37.5 21.5002C38.3284 20.6718 38.3284 19.3287 37.5 18.5002C36.6716 17.6718 35.3284 17.6718 34.5 18.5002L24.9372 28.063C24.5913 28.4089 24.4184 28.5818 24.2947 28.7837C24.185 28.9626 24.1042 29.1577 24.0552 29.3618C24 29.5919 24 29.8365 24 30.3257V32.0002Z",
    stroke: "#EF6820",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftjobsStIcon);
export default __webpack_public_path__ + "static/media/draftjobs_stIcon.c29db7e0afbb0317655e758e3fcb5b47.svg";
export { ForwardRef as ReactComponent };